import ContentLoader from '../../utils/ContentLoader';
import scrollWidth from '../../utils/scrollWidth';
import { disableScrollStyles } from '../../utils/events/disable-scroll';
import hasScrollbar from '../../utils/scrollDetection';

/**
 * Creates a new Overlay instance
 *
 * @class
 */
export default class Overlay {
    /**
     *
     * @param {string} id
     * @param {object} options
     */
    constructor(id, options) {

        let defaults = {
            overlayClass: '',
            showClass: '',
            overlayContainer: null,
            showOnLoad: true,
            removeOnClose: false,
            onHideCallback: null,
            onShowCallback: null
        };

        this.id = id;
        // this.activetimeout = null;
        this.options = Object.assign(defaults, options);

    }


    createAjax(href, target, doneCallback = () => {}, failCallback = () => {}) {

        if(this.options.showOnLoad){
            this.show();
        }


        const options = {
            destination: target,
            append: false
        };

        const contentLoader = new ContentLoader();
        contentLoader.newRequest(href, options, doneCallback, failCallback);
    }

    /**
     * Create the overlay - in this simple case it just adds the correct classes to the element and gets it ready to slide in.
     * @param {String} id -
     * @param {String} classname -
     */
    create(doneCallback) {
        if(this.options.showOnLoad){
            this.show();
        }
        doneCallback();
    }



    show(){
        //console.log("show", this.open);
        if (this.options.overlayContainer) {

            if (hasScrollbar()) {
                this.setBodyPadding();
            }

            disableScrollStyles(true);

            this.options.overlayContainer.classList.add(this.options.showClass);
        }

        if( typeof this.options.onShowCallback == 'function' ){
            this.options.onShowCallback();
        }

    }


    hide() {
        if (this.options.overlayContainer) {
            this.options.overlayContainer.classList.remove(this.options.showClass);

            disableScrollStyles(false);
            this.setBodyPadding(true);
        }

        if (this.options.onHideCallback) {
            this.options.onHideCallback();
        }
    }

    /**
     * @method setBodyPadding
     * Sets the body padding to disable
     */
    setBodyPadding(reset) {
        document.body.style.paddingRight = reset ? '' : scrollWidth + 'px';
    }

}
